import { Release } from '../types';
import { RELEASES } from '../constants';
import { supabase } from '../lib/supabase';

export const getReleases = (): Release[] => {
  return RELEASES; // For build-time sitemap generation
};

export const getReleasesForClient = async (): Promise<Release[]> => {
    const { data, error } = await supabase.from('releases').select('*');
    if (error) {
        console.error('Error fetching releases from Supabase:', error);
        return RELEASES;
    }
    return data as Release[];
};

export const getReleaseById = async (id: string): Promise<Release | undefined> => {
    const { data, error } = await supabase.from('releases').select('*').eq('id', id).single();
    if (error) {
        return RELEASES.find(r => r.id === id);
    }
    return data as Release;
};

export const addRelease = async (release: Omit<Release, 'id'>): Promise<Release> => {
  const newRelease = { ...release, id: `custom-rel-${Date.now()}` };
  const { data, error } = await supabase.from('releases').insert([newRelease]).select().single();
  if (error) {
      console.error('Error adding release:', error);
      throw error;
  }
  return data as Release;
};

export const updateRelease = async (id: string, updatedData: Partial<Release>): Promise<Release | null> => {
    const { data, error } = await supabase.from('releases').update(updatedData).eq('id', id).select().single();
    if (error) {
        console.error('Error updating release:', error);
        return null;
    }
    return data as Release;
};

export const deleteRelease = async (id: string): Promise<void> => {
  const { error } = await supabase.from('releases').delete().eq('id', id);
  if (error) {
      console.error('Error deleting release:', error);
  }
};

export const importDefaultReleases = async (): Promise<void> => {
    const { count, error: countError } = await supabase.from('releases').select('*', { count: 'exact', head: true });
    if (countError) {
        console.error('Error checking existing releases:', countError);
        throw new Error('Failed to check existing releases');
    }
    
    if (count && count > 0) {
        throw new Error('Database already contains releases. Please delete them first to re-import.');
    }

    const { error } = await supabase.from('releases').insert(RELEASES);
    if (error) {
        console.error('Error importing default releases:', error);
        throw new Error('Failed to import default releases');
    }
};


